import styled from "styled-components";

import { device } from "utils/sizes";
import { colourScheme } from "utils/styling/colours";
import { SubTitle as StyledSubTitle } from "utils/styling/typography.styled";

export const Main = styled.main`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    padding: 3rem 0.5rem;
    align-self: center;
    background-color: ${colourScheme.primaryDark};
    color: ${colourScheme.white};
    width: 100%;
    max-width: 100vw;
    min-height: calc(100vh - 5rem);

    ${device.lg} {
        padding: 4rem;
    }
`;

export const Title = styled(StyledSubTitle)`
    font-size: 2.5rem;
    text-align: center; /* Center text horizontally */
    color: ${colourScheme.white};

    ${device.lg} {
        font-size: 3rem;
    }
`;

// Centered subtitle
export const SubTitle = styled(StyledSubTitle)`
    font-size: 1.2rem;
    color: ${colourScheme.greyLight};
    text-align: center; /* Center text horizontally */
    margin-bottom: 2rem;

    ${device.lg} {
        font-size: 1.5rem;
    }
`;
